import React from 'react';
import PropTypes from 'prop-types';

import { FormContainer, SignUpSubmitButtonContainer } from './style';
import { UploadingAvatarContainer } from '../style';
import { SemiTransparentButton } from '../../../Layouts';
import { AvatarInput } from './AvatarInput';
import { AuthenticationInput } from './AuthenticationInput';

export const RegisterGymForm = ({
    avatar,
    fullName,
    email,
    password,
    passwordConfirmation,
    phoneNumber,
    avatarPreview,
    isRequestProcessing,
    uploadingResult,
    isSubmitButtonDisabled,
    validationErrors,
    handleChange,
    handleImageUpload,
    handleSubmit,
}) => {
    return (
        <FormContainer onSubmit={handleSubmit}>
            <AvatarInput value={avatar} onChange={handleImageUpload} name={'avatar'} preview={avatarPreview} />

            <AuthenticationInput
                value={fullName}
                onChange={handleChange}
                name={'fullName'}
                placeholder={'Gym name'}
                errorMessage={validationErrors.fullName}
            />
            <AuthenticationInput
                value={email}
                onChange={handleChange}
                name={'email'}
                type={'email'}
                placeholder={'Email'}
                errorMessage={validationErrors.email}
            />
            <AuthenticationInput
                value={password}
                onChange={handleChange}
                name={'password'}
                type={'password'}
                placeholder={'Password'}
                errorMessage={validationErrors.password}
            />
            <AuthenticationInput
                value={passwordConfirmation}
                onChange={handleChange}
                name={'passwordConfirmation'}
                type={'password'}
                placeholder={'Verify password'}
                errorMessage={validationErrors.passwordConfirmation}
            />
            <AuthenticationInput
                value={phoneNumber}
                onChange={handleChange}
                name={'phoneNumber'}
                placeholder={'Phone Number'}
                errorMessage={validationErrors.phoneNumber}
            />
            <SignUpSubmitButtonContainer>
                <SemiTransparentButton type={'submit'} disabled={isSubmitButtonDisabled}>
                    Sign up & agree to terms
                </SemiTransparentButton>
            </SignUpSubmitButtonContainer>

            {uploadingResult !== 0 && (
                <UploadingAvatarContainer>Uploading avatar: {uploadingResult}%</UploadingAvatarContainer>
            )}
        </FormContainer>
    );
};

RegisterGymForm.propTypes = {
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    passwordConfirmation: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    avatarPreview: PropTypes.string.isRequired,
    isRequestProcessing: PropTypes.bool.isRequired,
    isSubmitButtonDisabled: PropTypes.bool.isRequired,
    validationErrors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleImageUpload: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

RegisterGymForm.defaultProps = {
    fullName: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    phoneNumber: '',
    avatarPreview: '',
    isRequestProcessing: false,
    isSubmitButtonDisabled: false,
    validationErrors: {},
    handleChange: () => {},
    handleImageUpload: () => {},
    handleSubmit: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AuthenticationForms/RegisterGym.js